import React from 'react';
import { Link } from 'react-router-dom';
import AhmadImage from '../assets/Ahmad.jpg';
import WelcomeMessage from '../components/WelcomeMessage';

const Home: React.FC = () => {
  return (
    <div className="min-h-screen">
      {/* Welcome Message for Authenticated Users */}
      <div className="container mx-auto px-4 pt-4">
        <WelcomeMessage />
      </div>
      
      {/* Hero Section */}
      <section className="pakistan-gradient py-12 sm:py-16 md:py-20 text-white">
        <div className="container mx-auto px-4 text-center">
          <div className="fade-in">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6">
               Yakjehti Pakistan
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl mb-3 sm:mb-4">
              یکجہتی پاکستان ویلفیئر سوسائٹی
            </p>
            <p className="text-base sm:text-lg md:text-xl mb-6 sm:mb-8 max-w-3xl mx-auto px-2">
              United for Pakistan's Progress – Creating Jobs, Building Futures
            </p>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-4 justify-center items-center">
              <Link 
                to="/join-mission" 
                className="w-full sm:w-auto bg-white text-green-600 px-6 sm:px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition duration-300 glow-green text-center"
              >
                Join Our Mission
              </Link>
              <Link 
                to="/about" 
                className="w-full sm:w-auto border-2 border-white px-6 sm:px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-green-600 transition duration-300 text-center"
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Impact Statistics */}
      <section className="py-12 sm:py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8 sm:mb-12 text-pakistan-green">
            Our Impact in Numbers
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8">
            <div className="text-center fade-in">
              <div className="text-lg sm:text-xl md:text-2xl font-bold text-green-600 mb-1 sm:mb-2">Update Soon</div>
              <div className="text-sm sm:text-base md:text-lg text-gray-600">Jobs Created</div>
            </div>
            <div className="text-center fade-in">
              <div className="text-lg sm:text-xl md:text-2xl font-bold text-green-600 mb-1 sm:mb-2">Update Soon</div>
              <div className="text-sm sm:text-base md:text-lg text-gray-600">People Helped</div>
            </div>
            <div className="text-center fade-in">
              <div className="text-lg sm:text-xl md:text-2xl font-bold text-green-600 mb-1 sm:mb-2">Update Soon</div>
              <div className="text-sm sm:text-base md:text-lg text-gray-600">Active Programs</div>
            </div>
            <div className="text-center fade-in">
              <div className="text-lg sm:text-xl md:text-2xl font-bold text-green-600 mb-1 sm:mb-2">Update Soon</div>
              <div className="text-sm sm:text-base md:text-lg text-gray-600">Total Donations</div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-12 sm:py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
            <div className="slide-in-right">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 text-pakistan-green">
                Building Pakistan's Future Together
              </h2>
              <p className="text-base sm:text-lg text-gray-700 mb-4 sm:mb-6">
                Yakjehti Pakistan Welfare Society is dedicated to creating unity, generating employment 
                through manufacturing initiatives, and implementing comprehensive welfare programs across Pakistan.
              </p>
              <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base text-gray-700">
                <li className="flex items-start">
                  <span className="text-green-600 mr-2 sm:mr-3 mt-1 flex-shrink-0">✓</span>
                  <span>Manufacturing jobs in mobile accessories, textiles, and food processing</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2 sm:mr-3 mt-1 flex-shrink-0">✓</span>
                  <span>Free education and healthcare programs</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2 sm:mr-3 mt-1 flex-shrink-0">✓</span>
                  <span>Community training and skill development</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2 sm:mr-3 mt-1 flex-shrink-0">✓</span>
                  <span>Transparent donation management and impact reporting</span>
                </li>
              </ul>
            </div>
            <div className="fade-in mt-8 lg:mt-0">
              <div className="bg-gradient-to-r from-green-400 to-green-600 rounded-lg p-6 sm:p-8 text-white">
                <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4">Join Our Community</h3>
                <p className="text-sm sm:text-base mb-4 sm:mb-6">
                  Be part of Pakistan's transformation. Whether through volunteering, 
                  donating, or participating in our programs, every contribution matters.
                </p>
                <Link 
                  to="/join-mission" 
                  className="w-full sm:w-auto bg-white text-green-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition duration-300 text-center inline-block"
                >
                  Get Started Today
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Founder Chairman Section */}
      <section className="py-12 sm:py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8 sm:mb-12 text-pakistan-green">
            Our Leadership
          </h2>
          <div className="max-w-md mx-auto bg-white rounded-xl shadow-xl overflow-hidden hover:shadow-2xl transition duration-300">
            <div className="p-6 sm:p-8 text-center">
              {/* Image */}
              <div className="mb-6">
                <img 
                  src={AhmadImage} 
                  alt="Mian Ahmad Ali" 
                  className="w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48 rounded-full mx-auto object-cover border-4 border-green-500 shadow-lg"
                />
              </div>
              
              {/* Name */}
              <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-2">
                Mian Ahmad Ali
              </h3>
              
              {/* Position */}
              <p className="text-base sm:text-lg md:text-xl text-green-600 font-semibold">
                Founder and Chairman
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Programs Preview */}
      <section className="py-12 sm:py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8 sm:mb-12 text-pakistan-green">
            Our Programs
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            <div className="bg-white rounded-lg p-4 sm:p-6 shadow-lg hover:shadow-xl transition duration-300 glow-green">
              <div className="text-2xl sm:text-3xl mb-3 sm:mb-4">🏭</div>
              <h3 className="text-lg sm:text-xl font-bold mb-2 sm:mb-3">Manufacturing Programs</h3>
              <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">
                Create sustainable employment through mobile accessories, textiles, and food processing factories.
              </p>
              <a href="/programs" className="text-sm sm:text-base text-green-600 font-semibold hover:text-green-700">
                Learn More →
              </a>
            </div>
            <div className="bg-white rounded-lg p-4 sm:p-6 shadow-lg hover:shadow-xl transition duration-300 glow-green">
              <div className="text-2xl sm:text-3xl mb-3 sm:mb-4">🎓</div>
              <h3 className="text-lg sm:text-xl font-bold mb-2 sm:mb-3">Education & Training</h3>
              <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">
                Free education, skill development, and community training programs for all ages.
              </p>
              <a href="/programs" className="text-sm sm:text-base text-green-600 font-semibold hover:text-green-700">
                Learn More →
              </a>
            </div>
            <div className="bg-white rounded-lg p-4 sm:p-6 shadow-lg hover:shadow-xl transition duration-300 glow-green sm:col-span-2 lg:col-span-1">
              <div className="text-2xl sm:text-3xl mb-3 sm:mb-4">🏥</div>
              <h3 className="text-lg sm:text-xl font-bold mb-2 sm:mb-3">Healthcare Services</h3>
              <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">
                Community health clinics, medical camps, and healthcare accessibility programs.
              </p>
              <a href="/programs" className="text-sm sm:text-base text-green-600 font-semibold hover:text-green-700">
                Learn More →
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
